import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type RoleplayDetailsPerformanceFragment = { id: string, isSubmitted: boolean, score?: number | null, isAvailable: boolean, completedAt?: string | null, scorePercentage?: number | null, status: Types.PerformanceStatusEnum, attemptId: string, timeSpent: number, updatedAt: string, result?: Types.QuizResultEnum | null, maxSubmissionDetails?: { result?: Types.QuizResultEnum | null, score?: number | null, scorePercentage?: number | null } | null, attempts?: Array<{ attemptId: string, score?: number | null, status: Types.PerformanceStatusEnum, timeSpent: number, isSubmitted: boolean, updatedAt?: string | null, result?: Types.QuizResultEnum | null, scorePercentage?: number | null, attemptedAt?: string | null, report?: { coachingSummary?: string | null, headline?: string | null, overallScore: number, audioDurationSeconds?: number | null, durationSeconds: number, endReason: Types.RoleplayEndReasonEnum, generatedAt: string, strengths: Array<string>, improvements: Array<string>, passed: boolean, followUpPractice?: Array<{ linkedCriterionTitle?: string | null, rationale?: string | null, scenarioQuestion: string, suggestedResponse: string }> | null, videoAnalysis?: { status: string, statusReason?: string | null, eyeContact?: { rating: number, reason: string } | null, facialExpression?: { rating: number, reason: string } | null, handGestures?: { rating: number, reason: string } | null, headPose?: { rating: number, reason: string } | null, posture?: { rating: number, reason: string } | null } | null, speechMetrics?: { agentTalkRatioPercent?: number | null, averagePauseMs?: number | null, userFillerCount?: number | null, pacing?: { level: Types.SpeechMetricLevelEnum, levelLabel: string, narrative: string, title: string } | null, fillerWords?: { level: Types.SpeechMetricLevelEnum, levelLabel: string, narrative: string, title: string } | null, clarity?: { level: Types.SpeechMetricLevelEnum, levelLabel: string, narrative: string, title: string } | null, pauseConfidence?: { level: Types.SpeechMetricLevelEnum, levelLabel: string, narrative: string, title: string } | null, mostFrequentFillers?: Array<{ label: string, count: number }> | null } | null, transcript: Array<{ role: string, endMs?: number | null, speakerName?: string | null, startMs?: number | null, text: string, turnId: string }>, criterionScores: Array<{ comment?: string | null, criterionDescription?: string | null, criterionTitle: string, evidenceTurnIds?: Array<string> | null, score: number, weight?: number | null, commentedAtMs?: number | null, commentOpinion?: string | null }> } | null }> | null };


export type RoleplayDetailsPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const RoleplayDetailsPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment RoleplayDetailsPerformance on RoleplayPerformanceType {
  id
  isSubmitted
  score
  isAvailable
  completedAt
  scorePercentage
  status
  attemptId
  timeSpent
  updatedAt
  result
  maxSubmissionDetails {
    result
    score
    scorePercentage
  }
  attempts {
    attemptId
    score
    status
    timeSpent
    isSubmitted
    updatedAt
    result
    scorePercentage
    attemptedAt
    report {
      coachingSummary
      headline
      overallScore
      audioDurationSeconds
      durationSeconds
      endReason
      generatedAt
      strengths
      improvements
      followUpPractice {
        linkedCriterionTitle
        rationale
        scenarioQuestion
        suggestedResponse
      }
      videoAnalysis {
        eyeContact {
          rating
          reason
        }
        facialExpression {
          rating
          reason
        }
        handGestures {
          rating
          reason
        }
        headPose {
          rating
          reason
        }
        posture {
          rating
          reason
        }
        status
        statusReason
      }
      speechMetrics {
        pacing {
          level
          levelLabel
          narrative
          title
        }
        fillerWords {
          level
          levelLabel
          narrative
          title
        }
        clarity {
          level
          levelLabel
          narrative
          title
        }
        pauseConfidence {
          level
          levelLabel
          narrative
          title
        }
        mostFrequentFillers {
          label
          count
        }
        agentTalkRatioPercent
        averagePauseMs
        userFillerCount
      }
      transcript {
        role
        endMs
        speakerName
        startMs
        text
        turnId
      }
      criterionScores {
        comment
        criterionDescription
        criterionTitle
        evidenceTurnIds
        score
        weight
        commentedAtMs
        commentOpinion
      }
      passed
      overallScore
    }
  }
}
    `;